var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3857 10C17.4903 10 18.3857 9.10457 18.3857 8C18.3857 6.89543 17.4903 6 16.3857 6C15.2812 6 14.3857 6.89543 14.3857 8C14.3857 9.10457 15.2812 10 16.3857 10Z",
    fill: "#E66100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3857 18C17.4903 18 18.3857 17.1046 18.3857 16C18.3857 14.8954 17.4903 14 16.3857 14C15.2812 14 14.3857 14.8954 14.3857 16C14.3857 17.1046 15.2812 18 16.3857 18Z",
    fill: "#E66100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3857 26C17.4903 26 18.3857 25.1046 18.3857 24C18.3857 22.8954 17.4903 22 16.3857 22C15.2812 22 14.3857 22.8954 14.3857 24C14.3857 25.1046 15.2812 26 16.3857 26Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b3bd5616b8f56ff75b15a08e8ffb9db0.svg";
export { ForwardRef as ReactComponent };